import React from 'react';
import moment from 'moment';

interface StatusCircleProps {
    noPrazo?: boolean;
    valorLabel: any;
}

const StatusCircle = ({ noPrazo, valorLabel }: StatusCircleProps) => {
    const backgroundColorResult = noPrazo ? '#008000' : '#EE4E4E';
    return (
        <div className="status-circle">
            <span
                style={{
                    padding: '5px',
                }}>
                {valorLabel}
            </span>
            {noPrazo != undefined ? (
                <span
                    style={{
                        content: ' ',
                        borderRadius: '50%',
                        width: '10px',
                        height: '10px',
                        backgroundColor: backgroundColorResult,
                        display: 'inline-block',
                        padding: '5px',
                    }}>
                </span>
            ) : (
                <>
                </>
            )}

        </div>
    );
};

export default StatusCircle;
